import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { stack as Menu } from 'react-burger-menu';

const MobileNav = (props) => {
  const { pathname } = useLocation();

  const [menuOpen, setMenuOpen] = useState(false);

  const handleStateChange = (state) => setMenuOpen(state.isOpen);

  const closeMenu = () => setMenuOpen(false);

  return (
    <Menu
      right
      isOpen={menuOpen}
      onStateChange={handleStateChange}
      {...props}
    >
      {/* {props.isFTZEnabled && (
        <Link className={`${pathname.includes('competition') ? 'active' : ''}`} to="/competition/ftz-corporate-clash" onClick={closeMenu}>FTZ Corporate Clash</Link>
      )} */}
      {props.competitions && props.competitions.length > 0 && props.competitions.map((comp) => (
        <Link key={comp._id} className={`${pathname.includes(comp._id.replace(/\s+/g, "-").toLowerCase()) ? 'active' : ''}`} to={`/competition/${comp._id.replace(/\s+/g, "-").toLowerCase()}`} onClick={closeMenu}>{comp._id}</Link>
      ))}
      <Link className={`${pathname.includes('workshop') ? 'active' : ''}`} to="/workshop" onClick={closeMenu}>Workshops</Link>
      <a href="https://www.projectrock.com.my">Project Rock Homepage</a>
      <Link className={`${pathname.includes('online_ticket') || pathname === '/' ? 'active' : ''}`} to="/" onClick={closeMenu}>Online Tickets</Link>
      <Link className={`${pathname.includes('change_date') ? 'active' : ''}`} to="/change_date" onClick={closeMenu}>Change Visit Date</Link>
      {/* <Link to="/renew_member" onClick={closeMenu}>Membership Renewal</Link> */}
    </Menu>
  )
}

export default MobileNav;